import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Toast as Toast$1 } from 'reactstrap';
import { ToastHeader } from './ToastHeader.js';
import { ToastBody } from './ToastBody.js';

var Toast = function (_a) {
    var _b = _a.ariaLive, ariaLive = _b === void 0 ? 'assertive' : _b, _c = _a.ariaAtomic, ariaAtomic = _c === void 0 ? true : _c, border = _a.border, className = _a.className, children = _a.children, _d = _a.fade, fade = _d === void 0 ? true : _d, isOpen = _a.isOpen, _e = _a.light, light = _e === void 0 ? false : _e, _f = _a.role, role = _f === void 0 ? 'alert' : _f, _g = _a.tag, tag = _g === void 0 ? 'div' : _g, props = __rest(_a, ["ariaLive", "ariaAtomic", "border", "className", "children", "fade", "isOpen", "light", "role", "tag"]);
    return (jsx(Toast$1, __assign({ "aria-atomic": ariaAtomic, "aria-live": ariaLive, className: classNames('d-block', // override Bootstrap's .toast:not(.show) { display: none; } which breaks Fade transition
        border && 'toast-border', light && 'toast-light', className), fade: fade, "data-testid": "toast", isOpen: isOpen, role: role, tag: tag }, props, { children: children })));
};
Toast.Header = ToastHeader;
Toast.Body = ToastBody;

export { Toast };
